import Rete from 'rete';

import Effect from './Effect';
import { EFFECT_INPUT_SOCKET, EFFECT_OUTPUT_SOCKET } from '../SOCKETS';
import trackNodeHistory from '../utils/history/trackNodeHistory';

class EffectComponent extends Rete.Component {
  constructor(emitter) {
    super('Effect');
    this.render = 'vue';
    this.data.component = Effect;
    this.data.props = {};
    this.emitter = emitter;
  }

  builder = node => {
    const input = new Rete.Input('inputs', '', EFFECT_INPUT_SOCKET, true);
    const output = new Rete.Output('outputs', 'Then', EFFECT_OUTPUT_SOCKET);

    node.addInput(input);
    node.addOutput(output);
    trackNodeHistory(this, node, this.emitter);
  };
}

export default EffectComponent;
